// extracted by mini-css-extract-plugin
module.exports = {"listWrap":"listWrap--3JBDq","item":"item--3CJwd","imageWrap":"imageWrap--sRGuE","mask":"mask--106KU","title":"title--2Vhr7","describe":"describe--2-mnu"};